exports.IDS = {
  // IMG_URL: "http://127.0.0.1:7788",
  // IMG_URL: "http://192.168.16.23:7788",
  // IMG_URL: "https://funrepnode.profcymadev.com:7788",
  IMG_URL: "https://funreproulettenode.fun-rep.pro",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  Admin: 1,
  Roles: {
    Admin: 1,
    SuperSuperMaster: 2,
    SuperMaster: 3,
    Master: 4,
    Client: 5,
  },
};
